<template>
    <div class="app-container">
        <PdfTemplate2 id="pdfRef2" ref="pdfRef2" :customer="customerInfo" :table-list="tableList"></PdfTemplate2>
        <el-form ref="form" size="mini" :model="queryParams" :rules="rules" class="bj-query-form bj-query-form-for-cal-height">
            <BjDivider right-fixed>{{ $t('billingPage.OrderInfo') }}
                <template #right>
                    <el-button type="primary" class="main-btn" @click="save">{{ $t('saveText') }}</el-button>
                    <el-button type="primary" class="main-btn" v-if="tableData.length == 1" @click="printPdf">{{ $t('printText') }}</el-button>
                    <el-button type="primary" class="main-btn" v-if="tableData.length == 1" @click="downLoadPdf">{{ $t('billingPage.DOWNLOADDELIVERYNOTE') }}</el-button>
                </template>
            </BjDivider>
            <el-row :gutter="20" style="padding: 0 10px">
                <el-col :span="12" class="innerOrderNo" style="margin-bottom:10px;">
                    <el-form-item :label="$t('billingPage.OrderIdTip')" prop="orderDetails">
                        <BjInput v-model="webReference" disabled :placeholder="$t('AddAThirdPartyAfterSalesOrder.button')">
                            <el-button slot="append" @click="handleShowFnForDialogOrderList">{{ $t('AddAThirdPartyAfterSalesOrder.Associate') }}</el-button>
                        </BjInput>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-table :data="tableData" border script max-height="500px">
                        <el-table-column :label="$t('BjDialogListConfig.Thirdordernumber')" prop="webReference" align="center" />
                        <el-table-column :label="$t('BjDialogListConfig.TripartiteId')" prop="sapOrderNo" align="center" />
                        <el-table-column :label="$t('billingPage.CustomerName')" align="center">
                            <template slot-scope="scope">{{ customerList.bjGet(scope.row.cusId) }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('BjDialogListConfig.Salesstore')" prop="storeName" align="center" />
                        <el-table-column :label="$t('BjDialogListConfig.Saleschannel')" prop="channelTypeMeaning" align="center" />
                        <el-table-column :label="$t('BjDialogListConfig.Orderpulling')" prop="creationDate" align="center" />
                        <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
                            <template slot-scope="scope">
                                <el-button type="text" @click="onDelete(scope.$index)">{{ $t('delText') }}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <BjDivider right-fixed>{{ $t('billingPage.PalletQty') }}</BjDivider>
            <el-row :gutter="20" style="padding: 0 10px">
                <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.TotalPalletQty')" prop="totalPalletQty">
                        <BjInputNumber v-model="queryParams.totalPalletQty" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.WoodenStandardQty')" prop="standardPallet">
                        <BjInputNumber v-model="queryParams.standardPallet" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.ChepPalletQty')" prop="chepPallet">
                        <BjInputNumber v-model="queryParams.chepPallet" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.LoscamPalletQty')" prop="loscomPallet">
                        <BjInputNumber v-model="queryParams.loscomPallet" clearable />
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.ShrinkWrapQty')" prop="shripWrapQty">
                        <BjInputNumber v-model="queryParams.shripWrapQty" :placeholder="$t('billingPage.ShrinkWrapQty')" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.liftOnQty')" prop="liftOnQty">
                        <BjInputNumber v-model="queryParams.liftOnQty" :placeholder="$t('billingPage.ShrinkWrapQty')" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="$t('billingPage.strapWrapQty')" prop="strapWrapQty">
                        <BjInputNumber v-model="queryParams.strapWrapQty" :placeholder="$t('billingPage.ShrinkWrapQty')" clearable />
                    </el-form-item>
                </el-col> -->
                <el-col :span="colSpan">
                    <el-form-item :label="$t('route.BusinessBillingServiceItem')">
                        <el-select v-model="queryParams.serviceItem" multiple :placeholder="$t('chooseText')" class="full-width">
                            <el-option v-for="item in serviceItemList"
                                :key="item.rank" :label="item.rank" :value="item.rank">
                                <span>{{ item.rank }}:{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="`${$t('billingPage.LabourTime')}(${$t('billingPage.minText')})`" prop="labourTime">
                        <el-input-number style="width:100%" v-model="queryParams.labourTime" step-strictly :step="10" :min="0"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan*2">
                    <el-form-item :label="$t('billingPage.Comments')" prop="comments">
                        <BjInput v-model="queryParams.comments" show-word-limit type="textarea" :maxlength="MAX_LENGTH.BILLMAX" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- 选择订单,  初始  全部待发货  全部发货失败-->
        <BjDialogList ref="BjDialogOrderList" width="80%" :multiple="true" :config="$BjDialogListConfig.thirdOrderDefault($t('AddAThirdPartyAfterSalesOrder.associated'), { defaultQuery: { circulationStatus:0 } })" tag-name="outerOrderNo" @confirm="confirmForDialogOrderList" />
        <PdfTemplate id="pdfRef" ref="pdfRef" :data="dataInfo"></PdfTemplate>
    </div>
  </template>
  <script>
  import { purchaseApi, orderApi, goodsApi, serviceItem } from '@/api';
  import PdfTemplate from './components/pdfTemplate';
  import PdfTemplate2 from './components/pdfTemplate2';
  import viewMiXin from '@/utils/view-mixin.js';
  
  export default {
    name: 'BusinessBillingAddDeliveryNote',
    components: {
        PdfTemplate, PdfTemplate2
    },
    mixins: [viewMiXin],
    data() {
      return {
        colSpan: 6,
        queryParams: {
            outerOrderNo: '',
            innerOrderNo: '',
            orderDetails: [],
            orderType: 'DT',
            cusId: null,
            csgPallet: null,
            totalPalletQty: null,
            standardPallet: null,
            chepPallet: null,
            loscomPallet: null,
            shripWrapQty: null,
            labourTime: null,
            comments: '',
            liftOnQty: null,
            strapWrapQty: null,
            serviceItem: null
        },
        rules: {
            cusId: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
            orderDetails: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            // cusId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            totalPalletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            standardPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            chepPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            loscomPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            csgPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            shripWrapQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            liftOnQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            strapWrapQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        },
        dataInfo: {},
        customerInfo: {},
        dataList: [],
        webReference: null,
        showPdf: false,
        tableList: [],
        tableData: [],
        serviceItemList: []
      };
    },
    computed: {
        customerList() {
            return this.$store.getters.customerList;
        }
    },
    watch: {},
    created() {
        serviceItem.orderPalletList({
            currentPage: 0,
            page: 0,
            pagesize: 999,
            size: 999,
            status: 1,
        }).then(res=>{
            this.serviceItemList = res.content
        })
    },
    methods: {
        onDelete(index){
            this.tableData.splice(index,1)
            this.webReference = this.tableData.map(item => item.webReference).join(',');
        },
        printPdf() {
            let promise = Promise.resolve();
            const list = [];
            if(this.tableData.length == 1){
                orderApi.getInternalDetailByIdCode({
                    orderCode: this.tableData[0].innerOrderNo
                }).then(res => {
                    orderApi.getInternalSkuListByOrder({
                        orderId: res.orderInfoVO.id,
                        currentPage: 0,
                        page: 0,
                        size: 20,
                        pageSize: 20,
                    }).then(resp => {
                        resp.content.forEach(item => {
                            promise = promise.then(() => {
                                return new Promise(resolve => {
                                    goodsApi.getSku({
                                        currentPage: 0,
                                        page: 0,
                                        pageSize: 20,
                                        setFlag: 0,
                                        size: 20,
                                        skuCode: item.skuCode,
                                        status: [1, 2, 3, 4, 5],
                                    }).then(respp => {
                                        item.weight = respp.content[0].weight;
                                        list.push(item);
                                        resolve();
                                    });
                                });
                            });
                        });
                        return promise.then(() => {
                            this.customerInfo = {...res.orderInfoVO, ...res.receiverInfoVO, 
                                innerOrderNo: this.tableData[0].innerOrderNo,
                                totalWeight: list.reduce((pre, cur) => (pre += cur.weight), 0)
                            };
                            this.tableList = list;
                            this.$nextTick(()=>{
                                this.$refs.pdfRef2.exportPage();
                            })
                        });
                    });
                });
            }
        },
        downLoadPdf() {
            purchaseApi.getOrderPalletPageList({
                orderType: 'DT',
                innerOrderNo: this.tableData[0].innerOrderNo,
                outerOrderNo: this.tableData[0].outerOrderNo,
                currentPage: 0,
                page: 0,
                pageSize: 20,
                size: 20,
                status: 'Normal',
            }).then(res => {
                if (res.content.length > 0) {
                    orderApi.getDetailByInnerNo({no: this.tableData[0].innerOrderNo}).then(resp => {
                        this.dataInfo = resp;
                        this.$nextTick(() => {
                            this.$refs.pdfRef.exportPage();
                        });
                    });
                } else {
                    this.$message.warning(this.$t('billingPage.PleaseSaveFirst'));
                }
            });
        },
        handleShowFnForDialogOrderList() {
            this.$refs.BjDialogOrderList.show();
        },
        // 确认
        confirmForDialogOrderList(data) {
            if (data && !data[0].id) return;
            data.forEach(item =>{
                if(!this.tableData.find(jitem => jitem.id ==item.id)){
                    this.tableData.push(item)
                }
            })
            if (Array.isArray(data) && data.length) {
                // this.queryParams.outerOrderNo = data[0].outerOrderNo;
                // this.queryParams.innerOrderNo = data[0].innerOrderNo;
                const cusIdList = [...new Set(this.tableData.map(item => item.cusId))];
                this.webReference = this.tableData.map(item => item.webReference).join(',');
                this.queryParams.orderDetails = this.tableData.map(item => {
                    return {
                        innerOrderNo: item.innerOrderNo,
                        outerOrderNo: item.outerOrderNo
                    }
                })
                if(cusIdList.length > 1) return this.$message.warning(this.$t('billingPage.theSameOrDerTip'));
                this.queryParams.cusId = cusIdList[0]
            }
        },
        save() {
            const cusIdList = [...new Set(this.tableData.map(item => item.cusId))];
            if(cusIdList.length > 1) return this.$message.warning(this.$t('billingPage.theSameOrDerTip'));
            if(this.queryParams.serviceItem.length>0 && (!this.queryParams.labourTime || this.queryParams.labourTime==0)){
                return this.$message.warning('Labour Time is 0')
            }
            if(this.queryParams.labourTime>0 && this.queryParams.serviceItem.length==0){
                return this.$message.warning('Service Item is empty')
            }
            this.queryParams.orderDetails = this.tableData.map(item => {
                return {
                    innerOrderNo: item.innerOrderNo,
                    outerOrderNo: item.outerOrderNo
                }
            })
            this.showPdf = true;
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.queryParams.totalPalletQty != (Number(this.queryParams.standardPallet) + Number(this.queryParams.chepPallet) + Number(this.queryParams.loscomPallet))) return this.$message.warning(this.$t('billingPage.TotalPalletQty') + this.$t('billingPage.NeedEqual') + this.$t('billingPage.WoodenStandardQty') + '+' + this.$t('billingPage.ChepPalletQty') + '+' + this.$t('billingPage.LoscamPalletQty'));
                    this.queryParams.labourTime = Number(this.queryParams.labourTime);
                    purchaseApi.saveOrderPallet({
                        ...this.queryParams,
                        serviceItem: this.queryParams.serviceItem.join(',')
                    }).then(res => {
                        if (!res.failed) {
                            this.msgSuccess(this.$t('toast.operationSuccessText'));
                            // this.webReference = null;
                            // this.tableData = [];
                            // this.queryParams = {
                            //     outerOrderNo: '',
                            //     innerOrderNo: '',
                            //     orderDetails: [],
                            //     orderType: 'DT',
                            //     cusId: null,
                            //     csgPallet: null,
                            //     totalPalletQty: null,
                            //     standardPallet: null,
                            //     chepPallet: null,
                            //     loscomPallet: null,
                            //     shripWrapQty: null,
                            //     labourTime: null,
                            //     comments: '',
                            //     liftOnQty: null,
                            //     strapWrapQty: null,
                            //     serviceItem: null,
                            // }
                            setTimeout(() => {
                              this.$router.go(0);
                            }, 500);
                        }
                    });
                }
            });
        }
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .app-container .el-form-item__label{
    display: none;
  }
  ::v-deep .innerOrderNo .el-input-group__append {
    background: $main-dark;
    color: #ffffff;
  }
  </style>
